// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/49b7c7c376b572acbd72.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"87a519c8e55111461375","131":"357975c0c77981bc4ff6","132":"d291fa34792910db0233"}[chunkId] + ".chunk.js";
};